import { useEffect, useState } from "react";

export function DemoWarmupNotice() {
  const [waiting, setWaiting] = useState(false);
  useEffect(() => {
    const changed = (event: Event) => setWaiting(Boolean((event as CustomEvent).detail));
    window.addEventListener("studio-warming", changed);
    return () => window.removeEventListener("studio-warming", changed);
  }, []);
  if (!waiting) return null;
  return <div role="status" style={{position:"fixed",top:12,left:"50%",transform:"translateX(-50%)",zIndex:10000,padding:"14px 22px",borderRadius:12,background:"#132c27",color:"#fff",boxShadow:"0 8px 24px #0003",maxWidth:"90vw"}}>
    분석 서버를 준비하고 있습니다. 준비가 끝나면 자동으로 연결됩니다.
  </div>;
}
